var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4E05B7A6-16C6-4753-AB0F-1180E6345594") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Player-Nicknaming",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PlayerNickname-(State-3)-",
    transform: "translate(-1121.000000, -74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(1106.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(15.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Checkmark",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_checkmark_1740154",
    transform: "translate(0.000000, 1.200000)",
    fill: "#34A853",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3581489,0 C8.53617706,1.82592193 6.43974567,3.91688499 4.54526197,5.81287147 L1.49698189,3.21730382 L0,4.98591936 L3.86317907,8.26962157 L4.67807807,8.9637769 L5.43259557,8.20321352 C7.49109054,6.14029521 9.93777706,3.70250559 12,1.63581489 L10.3581489,0 Z",
    id: "Path"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.68466fb18069cd87f440894b7745eeb2.svg";
export { ForwardRef as ReactComponent };